

import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useTenantId } from "@shared/selectors/globalSelectors";
import { onboardingSystemAdminApi } from "./api";

// Custom hook that provides all onboarding data with tenant ID
export const useOnboardingData = () => {
  const tenantId = useTenantId();

  const orgData = useSmartQuery(
    QueryKeyFactory.module.onboarding.orgSetup(),
    () => onboardingSystemAdminApi.getOrgSetupData(tenantId),
    {
      enabled: !!tenantId,
    }
  );

  const subscriptionData = useSmartQuery(
    QueryKeyFactory.module.onboarding.subscription(),
    () => onboardingSystemAdminApi.getSubscriptionData(tenantId),
    {
      enabled: !!tenantId,
    }
  );

  const chartData = useSmartQuery(
    QueryKeyFactory.module.onboarding.charts(),
    () => onboardingSystemAdminApi.getChartData(tenantId),
    {
      enabled: !!tenantId,
    }
  );

  return {
    orgData,
    subscriptionData,
    chartData,
    tenantId,
  };
};

// Individual hooks if you prefer to use them separately
export const useOrgData = () => {
  const tenantId = useTenantId();
  const key = QueryKeyFactory.module.onboarding.orgSetup();
  console.log("QueryKey:", key);

  return useSmartQuery(
    key,
    () => onboardingSystemAdminApi.getOrgSetupData(tenantId),
    {
      enabled: !!tenantId,
    }
  );
};

export const useSubscriptionData = () => {
  const tenantId = useTenantId();
  const key = QueryKeyFactory.module.onboarding.subscription();

  return useSmartQuery(
    key,
    () => onboardingSystemAdminApi.getSubscriptionData(tenantId),
    {
      enabled: !!tenantId,
    }
  );
};

export const useChartData = () => {
  const tenantId = useTenantId();
  const key = QueryKeyFactory.module.onboarding.charts();

  return useSmartQuery(
    key,
    () => onboardingSystemAdminApi.getChartData(tenantId),
    {
      enabled: !!tenantId,
    }
  );
};